import { useQuery } from "@tanstack/react-query"
import { customersQuery } from "../lib/customersQuery"

export function useCustomersQuery(...args: Parameters<typeof customersQuery>) {
  return useQuery(customersQuery(...args))
}
